import React from 'react';
import { motion } from 'framer-motion';
import NavigationBar from 'components/ui/NavigationBar';
import Footer from 'components/ui/Footer';
import TestimonialsCarousel from './landing-page/components/TestimonialsCarousel';
import ExportInquiryForm from './landing-page/components/ExportInquiryForm';
import FAQ from './landing-page/components/FAQ';

const ContactPage = () => {
  return (
    <div className="min-h-screen gradient-background-main">
      {/* Navigation Bar */}
      <NavigationBar />
      
      {/* Page Header */}
      <section className="pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-lg text-text-primary mb-6">
              Get In Touch
            </h1>
            <p className="body-lg text-text-secondary max-w-4xl mx-auto">
              Ready to explore premium African agricultural products? Contact us to discuss 
              your requirements for horticultural products, agricultural commodities, oil seeds, and processed exports.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Export Inquiry Form - Moved higher for immediate access */}
      <section id="export-inquiry">
        <ExportInquiryForm />
      </section>

      {/* Testimonials Carousel */}
      <TestimonialsCarousel />

      {/* FAQ Section */}
      <FAQ />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactPage; 